import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import Iframe from 'components/Iframe/Iframe';
import { Box, Flex } from 'grid-styled';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import VideoAnnotationWrapper from 'components/VideoPlayer/VideoAnnotationWrapper';
import Annotation from 'components/VideoPlayer/Annotation';
import TimeRange from 'components/VideoPlayer/TimeRange';
import P from 'components/P/P';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import TextArea from 'components/TextArea/TextArea';
import {
  ANALYSE_BUILDING_BLOCKS,
  ANALYSE_TIME_RANGE,
  getSurveyUrlPDF,
  SURVEY_URL
} from '../../constants';
import { ROUTE_ANALYSE_INFO, ROUTE_ANALYSE_OVERVIEW, ROUTE_ANALYSE_SELECT } from 'RouteList';
import messages from './messages';
import Ahref from '../../components/Ahref/Ahref';
import { ROUTE_TIPS } from '../../RouteList';
import { Query } from 'react-apollo';
import {
  QUERY_GET_ANALYSE,
  QUERY_GET_VIDEO_ANALYSE,
  updateAnnotation,
  addAnnotation,
  finishAnalyse,
  QUERY_GET_VIDEO_ANALYSES,
  finishSurvey,
  deleteAnnotation
} from '../../services/graphql/video-analyse-query';
import Analyse from './store/model/Analyse';
import VideoAnalyse from './store/model/VideoAnalyse';
import ListItem from '../../components/List/ListItem';
import List from '../../components/List/List';
import Survey from './store/model/Survey';
import H2 from '../../components/H2/H2';

/* @TODO shortcuts nog aanvullen in copy files + testen :-) */
const getDefaultAnnotations = intl =>
  Array(6)
    .fill()
    .map((v, i) => ({
      label: intl.formatMessage(messages[`defaultAnnotation${i + 1}Label`]),
      value: intl.formatMessage(messages[`defaultAnnotation${i + 1}`])
    }));

const formatSecondsTo = sec => {
  var hrs = Math.floor(sec / 3600);
  var min = Math.floor((sec - hrs * 3600) / 60);
  var seconds = sec - hrs * 3600 - min * 60;
  seconds = Math.round(Math.round(seconds * 100) / 100);

  var result = hrs;
  result += ':' + (min < 10 ? '0' + min : min) + ':';
  result += seconds < 10 ? '0' + seconds : seconds;
  return result;
};

const findItemById = (list, id) => {
  let result = null;
  list.forEach(data => {
    data.data.forEach(items => {
      const buildingBlock = items.items.find(item => item.id === id);
      if (buildingBlock) {
        result = buildingBlock;
      }
    });
  });
  return result;
};

@inject('routing', 'uiState', 'authStore')
@observer
class Video extends Component {
  currentTime = 0;
  currentText = '';
  nextPauseTime = 0;
  currentSurvey = null;
  state = {
    activeAnnotation: null,
    surveyStarted: false,
    videoDuration: null,
    currentText: '',
    canSave: false,
    timeRanges: null,
    activeSurveyUrl: null
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener('message', this.onPostMessage, false);
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.onPostMessage);
  }

  onPostMessage = e => {
    console.log('onPostMessage e', e);
    try {
      const data = e.data;
      console.log('data', data);
      if (data && data.unique_identifier) {
        this.onSurveyFinished(
          this.currentSurvey,
          data.unique_identifier,
          data.score
        );
      }
    } catch (er) {
      console.log('Error postMessage iFrame', er);
    }
  };
  onMetadata(metadata) {
    if (this.state.videoDuration !== metadata.duration) {
      this.setState({
        videoDuration: metadata.duration,
        timeRanges: Video.getTimeRanges(metadata.duration, ANALYSE_TIME_RANGE)
      });
      this.showBuildingBlockToSurvey();
    }
  }

  async onAddUpdateAnnotation(text) {
    const { analyseId } = this.props;
    const { activeAnnotation } = this.state;
    let currentAnnotation;
    const refetchQueries = [
      { query: QUERY_GET_ANALYSE, variables: { analyseId } }
    ];

    if (activeAnnotation) {
      currentAnnotation = this.activeAnalyse.annotations.find(
        a => a.id === activeAnnotation.id
      );
      currentAnnotation = await updateAnnotation(
        {
          id: currentAnnotation.id,
          text
        },
        refetchQueries
      );
    } else {
      currentAnnotation = await addAnnotation(
        {
          analyseId: this.activeAnalyse.id,
          time: this.currentTime,
          text
        },
        refetchQueries
      );
    }
    if (currentAnnotation) {
      this.setState({
        currentText: text,
        canSave: false,
        activeAnnotation: currentAnnotation
      });
    }
  }

  setActiveAnnotation(annotation) {
    this.currentText = annotation.text;
    this.currentTime = annotation.time;

    if (this.videoPlayer.isPlaying()) {
      this.videoPlayer.pause();
    }

    this.videoPlayer.player.currentTime(this.currentTime);

    this.setState({
      activeAnnotation: annotation,
      currentText: this.currentText,
      canSave: false
    });
  }

  async onDeleteAnnotation(annotation) {
    const { uiState, intl, analyseId } = this.props;
    const { activeAnnotation } = this.state;
    uiState.createAlert({
      title: intl.formatMessage(messages.analyseVideoModalDeleteTitle),
      message: intl.formatMessage(messages.analyseVideoModalDeleteMessage),
      ok: intl.formatMessage(messages.analyseVideoModalDeleteOK),
      okHandler: async () => {
        await deleteAnnotation(
          {
            annotationId: annotation.id
          },
          [{ query: QUERY_GET_ANALYSE, variables: { analyseId } }]
        );
        this.currentText =
          activeAnnotation && annotation.id === activeAnnotation.id
            ? ''
            : this.currentText;
        this.setState({
          currentText:
            activeAnnotation && annotation.id === activeAnnotation.id
              ? ''
              : this.currentText,
          canSave: false,
          activeAnnotation:
            activeAnnotation && annotation.id === activeAnnotation.id
              ? null
              : activeAnnotation
        });
      },
      cancel: intl.formatMessage(messages.analyseVideoModalDeleteCancel)
    });
  }

  async onSurveyFinished(survey, unique_identifier, score) {
    console.log('survey finished', survey.finished);
    if (!survey.finished) {
      survey.setFinished(unique_identifier, score);
      const response = await finishSurvey(
        {
          analyseId: this.activeAnalyse.id,
          buildBlockId: survey.buildingBlockId,
          index: survey.index,
          last: survey.last,
          finished: survey.finished,
          score: survey.score,
          sapId: survey.sapId
        },
        [
          {
            query: QUERY_GET_ANALYSE,
            variables: { analyseId: this.activeAnalyse.id }
          }
        ]
      );
      console.log('response', response);
      this.activeAnalyse.surveys.push(new Survey(response));
      this.showBuildingBlockToSurvey(response);
    }
  }

  showSurvey(survey, force) {
    console.log('show the survey');
    this.currentSurvey = survey;
    let buildingBlockUrl = findItemById(
      ANALYSE_BUILDING_BLOCKS,
      survey.buildingBlockId
    );

    console.log('survey', this.currentSurvey);
    console.log('buildingBlockUrl', buildingBlockUrl);

    const urlId = buildingBlockUrl.url;

    /*let URL = survey.finished
      ? getSurveyUrlPDF(urlId, survey.sapId)
      : `${SURVEY_URL}${urlId}`;*/

    let URL = `${SURVEY_URL}${urlId}`;

    if (this.state.activeSurveyUrl !== URL || force) {
      console.log('IFRAME', URL);
      if (force) URL = URL + `&t=${new Date().getTime()}`;
      this.setState({ activeSurveyUrl: URL });
    }
  }

  showBuildingBlockToSurvey(nextSurvey) {
    const { authStore: { isImpersonator, user } } = this.props;
    const currentUser = isImpersonator || user;
    const currentIndex = this.getCurrentIndex();
    console.log('currentIndex', currentIndex);
    console.log('nextSurvey', nextSurvey);
    const survey = this.activeAnalyse.getSurveyToShow(
      currentUser.email,
      currentIndex,
      this.state.timeRanges.length === currentIndex,
      nextSurvey
    );
    if (survey) {
      this.showSurvey(survey, nextSurvey && nextSurvey.sapId === survey.sapId);
    }
  }

  getCurrentIndex() {
    const index = this.state.timeRanges.findIndex(tr => {
      return tr >= this.currentTime;
    });
    if (index === -1) {
      return this.state.timeRanges.length;
    }
    return index;
  }

  onTimeUpdate(time) {
    this.currentTime = Math.round(time * 100) / 100;

    const { activeAnnotation } = this.state;
    if (activeAnnotation && activeAnnotation.time !== this.currentTime) {
      if (this.state.currentText !== '') {
        this.setState({
          currentText: '',
          canSave: false,
          activeAnnotation: null
        });
      } else {
        this.setState({ activeAnnotation: null });
      }
    }

    if (this.videoPlayer.isPlaying()) {
      if (this.nextPauseTime <= time) {
        this.videoPlayer.pause();
        this.videoPlayer.player.currentTime(this.nextPauseTime);
        this.nextPauseTime = this.getNextPauseTime();
        if (this.videoPlayer.isFullscreen()) this.videoPlayer.exitFullscreen();
      }
    } else {
      this.nextPauseTime = this.getNextPauseTime();
    }

    this.showBuildingBlockToSurvey();
  }

  onPlay() {
    this.nextPauseTime = this.getNextPauseTime();
  }

  getNextPauseTime() {
    return this.state.timeRanges.find(tr => {
      return this.currentTime < tr;
    });
  }

  onTextChange(text) {
    const { activeAnnotation } = this.state;
    this.currentText = text;
    let canSave = false;
    if (text !== '') {
      if (activeAnnotation && activeAnnotation.text !== this.currentText) {
        canSave = true;
      } else if (!activeAnnotation) {
        canSave = true;
      }
    }

    if (this.state.canSave !== canSave) {
      this.setState({ canSave, currentText: this.currentText });
    }
  }

  onTextBlur() {
    const { activeAnnotation } = this.state;
    if (activeAnnotation) {
      this.setState({ currentText: this.currentText });
    }
  }

  static getTimeRanges(videoDuration, analyseTimeRange) {
    const timeRanges = [];
    if (videoDuration && videoDuration > analyseTimeRange) {
      const ranges = Math.floor(videoDuration / analyseTimeRange);
      for (let i = 0; i < ranges; i++) {
        timeRanges.push(Math.round(i * analyseTimeRange + analyseTimeRange));
      }
    }
    return timeRanges;
  }

  async onReadyClick() {
    const {
      videoAnalyseId,
      routing: { push },
      authStore: { user, isImpersonator }
    } = this.props;
    this.activeAnalyse.finished = true;
    await finishAnalyse(
      {
        id: this.activeAnalyse.id,
        finished: true
      },
      [
        {
          query: QUERY_GET_VIDEO_ANALYSES,
          variables: { personId: isImpersonator ? isImpersonator.id : user.id }
        }
      ]
    );
    push(`${ROUTE_ANALYSE_OVERVIEW}/${videoAnalyseId}`);
  }

  onGoToTipAndTricks() {
    const { routing: { push } } = this.props;
    push(`${ROUTE_TIPS}`);
  }

  goBack() {
    const { routing: { push }, analyseId, videoAnalyseId } = this.props;
    push(`${ROUTE_ANALYSE_INFO}/${videoAnalyseId}/${analyseId}`);
  }

  render() {
    const {
      intl,
      analyseId,
      videoAnalyseId,
      authStore: { isImpersonator, user }
    } = this.props;
    const { activeAnnotation, timeRanges } = this.state;
    const currentUser = isImpersonator || user;
    return (
      <Query
        query={QUERY_GET_VIDEO_ANALYSE}
        variables={{ videoAnalyseId }}
        fetchPolicy={'cache-and-network'}
      >
        {({ loading, error, data }) => {
          if (loading) return <P>Bezig met laden...</P>;
          if (error) return <P danger>{error.message}</P>;
          if (!data.getVideoAnalyse) {
            return (
              <P danger>{intl.formatMessage(messages.analiseErrorLoading)}</P>
            );
          }
          const activeVideoAnalyse = new VideoAnalyse(data.getVideoAnalyse);

          this.activeVideoAnalyse = activeVideoAnalyse;
          const videoJsOptions = {
            playbackRates: [0.5, 1, 1.5, 2],
            sources: [
              {
                src: activeVideoAnalyse.video.s3,
                type: 'video/mp4'
              }
            ]
          };

          return (
            <Query
              query={QUERY_GET_ANALYSE}
              variables={{ analyseId }}
              fetchPolicy={'cache-and-network'}
            >
              {({ loading, error, data }) => {
                if (loading) return <P>Bezig met laden...</P>;
                if (error) return <P danger>{error.message}</P>;
                const analyse = data.getAnalyse;
                console.log('analyse', analyse);

                if (!analyse) {
                  return (
                    <P danger>
                      {intl.formatMessage(messages.analiseErrorLoading)}
                    </P>
                  );
                }
                const activeAnalyse = new Analyse(analyse);
                this.activeAnalyse = activeAnalyse;
                return (
                  <Fragment>
                    {activeAnalyse && (
                      <Flex flexWrap="wrap">
                        <Box width={1 / 1} mt={4} mb={2}>
                          <H2 upper>
                            <FormattedMessage {...messages.analyseVideoTitle} />
                          </H2>
                        </Box>
                        <Box width={1 / 1} mt={1} mb={4}></Box>
                        <Flex
                          width={[1, 1, 1 / 2]}
                          pr={[0, 0, 2]}
                          flexWrap="wrap"
                        >
                          <Box width={1 / 1}>
                            <VideoPlayer
                              ref={videoPlayer => {
                                this.videoPlayer = videoPlayer;
                              }}
                              {...videoJsOptions}
                              onTimeUpdate={currentTime =>
                                this.onTimeUpdate(currentTime)
                              }
                              onMetadata={metadata => this.onMetadata(metadata)}
                              onPlay={() => this.onPlay()}
                            />
                            <VideoAnnotationWrapper>
                              {activeAnalyse.annotations.map(annotation => (
                                <Annotation
                                  procent={
                                    annotation.time /
                                    this.state.videoDuration *
                                    100
                                  }
                                  key={annotation.id}
                                  selected={
                                    activeAnnotation
                                      ? activeAnnotation.time ===
                                        annotation.time
                                      : false
                                  }
                                  onClick={() =>
                                    this.setActiveAnnotation(annotation)
                                  }
                                />
                              ))}
                              {timeRanges &&
                                timeRanges.length > 0 &&
                                timeRanges.map(tr => (
                                  <TimeRange
                                    key={tr}
                                    procent={
                                      tr / this.state.videoDuration * 100
                                    }
                                  />
                                ))}
                            </VideoAnnotationWrapper>
                            <Flex width={1 / 1}>
                              {getDefaultAnnotations(intl).map((an, i) => (
                                <Button
                                  key={i}
                                  secondary
                                  inOneLine
                                  onClick={() =>
                                    this.onAddUpdateAnnotation(an.value)
                                  }
                                >
                                  {an.label}
                                </Button>
                              ))}
                            </Flex>
                            <Box width={1 / 1} my={2}>
                              <TextArea
                                textValue={this.state.currentText}
                                onChange={text => this.onTextChange(text)}
                                onBlur={() => this.onTextBlur()}
                              />
                            </Box>
                            <Flex justifyContent="space-between">
                              <Button
                                small
                                success
                                disabled={!this.state.canSave}
                                onClick={() =>
                                  this.onAddUpdateAnnotation(this.currentText)
                                }
                              >
                                {activeAnnotation ? (
                                  <FormattedMessage
                                    {...messages.analiseVideoAnnotateButtonUpdate}
                                  />
                                ) : (
                                  <FormattedMessage
                                    {...messages.analiseVideoAnnotateButtonAdd}
                                  />
                                )}
                              </Button>
                              {activeAnnotation && (
                                <Button
                                  small
                                  danger
                                  onClick={() =>
                                    this.onDeleteAnnotation(activeAnnotation)
                                  }
                                >
                                  <Flex alignItems="center" width={1}>
                                    <Icon
                                      id="delete"
                                      fillColor={props =>
                                        props.theme.colors.danger
                                      }
                                    />
                                  </Flex>
                                </Button>
                              )}
                            </Flex>
                            <List>
                              {activeAnalyse.annotations
                                .sort((obj1, obj2) => obj1.time - obj2.time)
                                .map(annotation => (
                                  <ListItem
                                    key={annotation.id}
                                    anotationList
                                    metaData={
                                      currentUser.id !== annotation.person.id
                                        ? `${annotation.person.firstname} ${
                                            annotation.person.lastname
                                          }`
                                        : ''
                                    }
                                    content={`${formatSecondsTo(
                                      annotation.time
                                    )} - ${annotation.text}`}
                                  >
                                    <Flex
                                      width={[1, 3 / 7]}
                                      justifyContent="flex-end"
                                      mb={[3, 0]}
                                    >
                                      <Box width="auto" ml={2}>
                                        <Button
                                          small
                                          primary
                                          onClick={() =>
                                            this.setActiveAnnotation(annotation)
                                          }
                                        >
                                          <Flex alignItems="center">
                                            <Icon id="edit" />
                                          </Flex>
                                        </Button>
                                      </Box>
                                      <Box width="auto" ml={2}>
                                        <Button
                                          small
                                          danger
                                          onClick={() =>
                                            this.onDeleteAnnotation(annotation)
                                          }
                                        >
                                          <Flex alignItems="center">
                                            <Icon
                                              id="delete"
                                              fillColor={props =>
                                                props.theme.colors.danger
                                              }
                                            />
                                          </Flex>
                                        </Button>
                                      </Box>
                                    </Flex>
                                  </ListItem>
                                ))}
                            </List>
                            <Box width={1 / 1} pt={3} mb={[3, 3, 0]}>
                              <Button
                                primary
                                onClick={() => {
                                  this.goBack();
                                }}
                                style={{ marginRight: 8 }}
                              >
                                <FormattedMessage
                                  {...messages.analyseBackButton}
                                />
                              </Button>
                              <Button
                                primary
                                onClick={() => this.onReadyClick()}
                              >
                                <FormattedMessage
                                  {...messages.analiseVideoReadyButton}
                                />
                              </Button>
                            </Box>
                          </Box>
                        </Flex>
                        <Flex width={[1, 1, 1 / 2]} pl={[0, 0, 2]} pt={[3, 0]}>
                          <Box width={1 / 1}>
                            {activeAnalyse &&
                              this.state.activeSurveyUrl && (
                                <Fragment>
                                  <Iframe
                                    src={this.state.activeSurveyUrl}
                                    height={'100%'}
                                    width="100%"
                                  />
                                  <div style={{ display: 'flex' }}>
                                    <div style={{ flex: '70%' }}>
                                      {activeAnalyse.hasFinishedAllSurveys &&
                                        activeAnalyse.surveys.map(survey => {
                                          console.log('survey', survey);
                                          const buildingBlock = findItemById(
                                            ANALYSE_BUILDING_BLOCKS,
                                            survey.buildingBlockId
                                          );
                                          const isCurrent =
                                            this.currentSurvey.id === survey.id;
                                          if (
                                            buildingBlock &&
                                            survey.finished
                                          ) {
                                            return (
                                              <Fragment
                                                key={`${
                                                  survey.buildingBlockId
                                                } ${survey.last}`}
                                              >
                                                <br />
                                                <Ahref
                                                  active={isCurrent}
                                                  onClick={() =>
                                                    this.showSurvey(survey)
                                                  }
                                                >
                                                  {`${buildingBlock.label} ${
                                                    survey.last
                                                      ? '(Reflectie)'
                                                      : ''
                                                  }`}
                                                </Ahref>
                                              </Fragment>
                                            );
                                          }
                                          return null;
                                        })}
                                    </div>
                                    {activeAnalyse.hasFinishedAllSurveys && (
                                      <div style={{ flex: '30%' }}>
                                        <br />
                                        <Button
                                          primary
                                          full
                                          onClick={() =>
                                            this.onGoToTipAndTricks()
                                          }
                                        >
                                          <FormattedMessage
                                            {...messages.analiseVideoTipsAndTricksButton}
                                          />
                                        </Button>
                                      </div>
                                    )}
                                  </div>
                                </Fragment>
                              )}
                          </Box>
                        </Flex>
                      </Flex>
                    )}
                  </Fragment>
                );
              }}
            </Query>
          );
        }}
      </Query>
    );
  }
}

export default injectIntl(Video);



// WEBPACK FOOTER //
// ./src/containers/analyse/Video.js